export const updateToasts = data => ({
  type: 'UPDATE_TOASTS',
  payload: data,
});


